import { render, staticRenderFns } from "./InviteMembersPanel.vue?vue&type=template&id=383516a7&scoped=true"
import script from "./InviteMembersPanel.vue?vue&type=script&lang=js"
export * from "./InviteMembersPanel.vue?vue&type=script&lang=js"
import style0 from "./InviteMembersPanel.vue?vue&type=style&index=0&id=383516a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383516a7",
  null
  
)

export default component.exports